export const API = {
  USERS_SERVICE: 'https://www.trackmysports.com:7102',
  BACK_OFFICE_SERVICE: 'https://www.trackmysports.com:7103',
  SCRAPER_SERVICE: 'https://www.trackmysports.com:7104',
  AUTH_SERVICE: 'https://www.trackmysports.com:7105'
};
